import React from 'react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

import { AccountNumberInputForeign, AccountNumberInputLocal, AccountNumberInputLocalPrepaid, AccountNumberInputForeignPrepaid } from '../../AddCustomerSteps/AboutCustomer';
import Api from '../../../../api/Api.js';
import CustomerEndpoints from '../../../../api/CustomerEndpoints';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class ChangeAccountNumberDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            account_noState: '',
            account_no: props.account_no.toUpperCase(),
            foreign: props.account_no.toUpperCase().endsWith("F") && (props.account_no.length === 7),
            prepaid: props.prepaid,
            loading: false
        }
    }

    verifyAccountNo(value) {
        var accountNoRex = /^(XXX)*[A-Za-z0-9]{3}[0-9]{3}F*$/;
        if (accountNoRex.test(value)) {
            return true;
        }
        return false;
    }

    changeAccountNo(account_no) {

        var newState = { account_no, account_noState: '' };

        if (this.verifyAccountNo(account_no)) {
            newState.account_noState = 'success';
        }
        else {
            newState.account_noState = 'error';
        }
        this.setState({ ...newState })
    }

    submit() {
        var newAccountNo = (this.state.foreign && !this.state.account_no.endsWith('F') ? this.state.account_no + "F" : (!this.state.foreign ? this.state.account_no.substr(0,6) : this.state.account_no)).toUpperCase();

        if(!newAccountNo.startsWith('XXX') && this.state.prepaid) {
            newAccountNo = "XXX" + newAccountNo;
        }

        if (this.state.account_noState === 'success' || this.state.account_noState === '') {
            this.setState({ loading: true }, () =>
                Api.post(CustomerEndpoints.changeAccountNumber, { customer_id: this.props.customer_id, account_no: newAccountNo })
                    .then(() => {
                        this.props.close();
                        this.props.refresh(newAccountNo);
                        this.setState({ loading: false })
                    })
                    .catch((e) => this.setState({ loading: false }, () => console.error(e)))
            )
        }
    }

    render() {

        const { classes } = this.props;

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Change Account Number</DialogTitle>
                <DialogContent>
                    <CustomInput
                        success={this.state.account_noState === "success"}
                        error={this.state.account_noState === "error"}
                        labelText={
                            <span>
                                Account Number <small>(required)</small>
                            </span>
                        }
                        id="account_no"
                        formControlProps={{
                            fullWidth: true
                        }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                            onChange: event => this.changeAccountNo(event.target.value),
                            value: this.state.account_no,
                            inputComponent: this.state.foreign ? (this.state.prepaid ? AccountNumberInputForeignPrepaid : AccountNumberInputForeign) : (this.state.prepaid ? AccountNumberInputLocalPrepaid : AccountNumberInputLocal)
                        }}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={this.state.foreign}
                                onChange={() => this.setState({ foreign: !this.state.foreign })}
                                value={this.state.foreign}
                                classes={{
                                    switchBase: classes.switchBase,
                                    checked: classes.switchChecked,
                                    icon: classes.switchIcon,
                                    iconChecked: classes.switchIconChecked,
                                    bar: classes.switchBar
                                }}
                            />
                        }
                        classes={{
                            label: classes.label
                        }}
                        label="Foreign Account?"
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>


                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                Set Account Number
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(ChangeAccountNumberDialog);